import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { initPostHog } from './lib/posthog';
document.title = 'Caveo // Digital safety your family will actually do';
initPostHog();
render(<AppRouter data-id="element-409" />, document.getElementById('root'));